<template>
  <div class="goldenLV"  v-on:scroll="handleScroll(event)" style="  overflow: hidden;">
    <div id="homeside">
      <a href="https://www.facebook.com/kingstonecy1986/">
      <img src="./../assets/icon-fb/icon-fb-m.png"
            srcset="./../assets/icon-fb/icon-fb-m@2x.png 2x,
                   ./../assets/icon-fb/icon-fb-m@3x.png 3x"
            class="icon">
      </a>
      <a href="mailto:cs@kingstonecy.com.tw" target="_blank">      
        <img src="./../assets/icon-mail/icon-mail-m.png"
          srcset="./../assets/icon-mail/icon-mail-m@2x.png 2x,
                  ./../assets/icon-mail/icon-mail-m@3x.png 3x"
          class="icon"></a>
    </div> 
    <div class="article">
      <div id="label"><h2 id="labeltext">金石世築 </h2><hr id="labelhr"></div>
      <div class="content">
        <div class="description">
          <p id="description_text"> </p>
          <hr :class="'description_hr '+'activehr'">
          <span :class="'description_box '+'activehr'">
              <table>
                <tr>
                  <td class="descri_title">建案規劃</td>
                  <td class="descri_content">未提供</td>
                </tr>
                <tr>
                  <td class="descri_title">所在區域</td>
                  <td class="descri_content">嘉義市西區</td>
                </tr>
                <tr>
                  <td class="descri_title">諮詢專線</td>
                  <td class="descri_content">未提供</td>
                </tr>                
                <tr>
                  <td class="descri_title">基地位址</td>
                  <td class="descri_content">四維路及竹圍路及國聖二街</td>
                </tr>                
                <tr>
                  <td class="descri_title">接待中心</td>
                  <td class="descri_content">嘉義市西區世賢路二段299號</td>
                </tr>
              </table>
          </span>
        </div>
        <div class="figure">
          <img src="./../assets/world/world.png" id="goldenlv">          
        </div>
      </div>
      <div class="house">
        <hr :class="'description_hr '+this.houseanimation" id="description_hr_2">
        <span :class="'house_box '+this.houseanimation" style="width:26%">
            <table>
              <tr>
                <td class="descri_title">地坪</td>
                <td class="descri_content">32-42 坪</td>
              </tr>
              <tr>
                <td class="descri_title">建坪</td>
                <td class="descri_content">77-98 坪</td>
              </tr>
              <tr>
                <td class="descri_title">面寬</td>
                <td class="descri_content">4.9-6.5 米</td>
              </tr>                
              <tr>
                <td class="descri_title">座向</td>
                <td class="descri_content">西南、西北、東北</td>
              </tr>                
              <tr>
                <td class="descri_title">總戶數</td>
                <td class="descri_content">16戶</td>
              </tr>
            </table>
        </span>
        <hr :class="'description_hr '+this.houseanimation" id="description_hr_3">
        <span :class="'house_box '+this.houseanimation" style="width:26%">
            <table>
              <tr>
                <td class="descri_title">基地面積</td>
                <td class="descri_content">566坪</td>
              </tr>
              <tr>
                <td class="descri_title">房間規劃</td>
                <td class="descri_content">6房</td>
              </tr>
              <tr>
                <td class="descri_title">樓層規劃</td>
                <td class="descri_content">4樓半</td>
              </tr>                
              <tr>
                <td class="descri_title">透天車位</td>
                <td class="descri_content">1-2位</td>
              </tr>                
              <tr>
                <td class="descri_title">交通環境</td>
                <td class="descri_content">四維路及竹圍路及國聖二街</td>
              </tr>
            </table>
        </span>
        <hr :class="'description_hr '+this.houseanimation" id="description_hr_4">
        <span :class="'house_box '+this.houseanimation" style="width:40%">
            <table>
              <tr>
                <td class="descri_title">公園綠地</td>
                <td class="descri_content">未提供</td>
              </tr>
              <tr>
                <td class="descri_title">鄰近國小</td>
                <td class="descri_content" style="width: 360px;">世賢國小</td>
              </tr>
              <tr>
                <td class="descri_title">鄰近國中</td>
                <td class="descri_content" style="width: 360px;">北興國中</td>
              </tr>                
              <tr>
                <td class="descri_title">鄰近大學</td>
                <td class="descri_content">未提供</td>
              </tr>                
              <tr>
                <td class="descri_title">查看地圖</td>
                <td class="descri_content">未提供</td>
              </tr>
            </table>
        </span>
      </div>
      <div class="shop">
        <hr :class="'shop_hr '+this.shopanimation" id="description_hr_5">
        <span :class="'shop_box '+this.shopanimation" style="width:95%">
        <table><tr>
            <td class="shop_title">購物環境</td>
            <td class="shop_content">未提供</td>
        </tr></table></span>
      </div>
      <div class="photo_container">
        <img src="./../assets/world/world.png" 
            class="photo" :id="this.photoshow1">       
      </div>
    </div>

  </div>
  
</template>
 
<script>
export default {
  data(){
    return {      
      windowscrollY:"",
      // showanimation:'',
      houseanimation:'',
      shopanimation:'',
      photoshow1:"",
      photoshow2:"",
      photoshow3:"",
      photoshow4:"",
      }
  },
  methods: {
      handleScroll (event) {
        this.windowscrollY = window.scrollY
        // console.log(this.windowscrollY)
        // if (this.windowscrollY > 120) {
        //     this.showanimation = 'activehr'
        // }
        if (this.windowscrollY > 300) {
            this.houseanimation = 'activehrlate'
        }
        if (this.windowscrollY > 490) {
            this.shopanimation = 'activehrlater'
        }
        if (this.windowscrollY > 760) {
            this.photoshow1 = 'photoshow1'
        }        
        if (this.windowscrollY > 1050) {
            this.photoshow2 = 'photoshow2'
        }        
        if (this.windowscrollY > 2050) {
            this.photoshow3 = 'photoshow3'
        }
        if (this.windowscrollY > 2700) {
            this.photoshow4 = 'photoshow4'
        }
      // else console.log('no')
      }
  },
  created () {
      window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.goldenLV{
  width: 100%;
  height: auto;
  margin:0;
}
#homeside, .article{
  display: inline-block;
}
#homeside{
  position:relative;
  text-align: center;
  float: left;
  width: 46px;
  height: auto;
  margin: 300px 120px 10px 48px;
  /* margin: 300px 0px 10px 48px; */
}
.icon {
  position:relative;
  height: 28px;
  margin: 9px 18px;
  object-fit: contain;
}
.icon:hover{
  cursor: pointer;
}
.article{
  width:80%;
  height: auto;
}
#label {
  margin: 0 0 10px 0;
  width:  100%;
  height: 60px;
}
@keyframes show-draw{
    100% {
        opacity: 1;
        }
    }
#labeltext {
  margin: auto 0;
  float: left;
  width:  15%;
  height: 60px;
  font-size: 36px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.27px;
  color: #bbb19d;
  opacity: 0;
  animation: show-draw 0.6s linear forwards;
  -webkit-animation: show-draw 0.6s linear forwards;
  animation-delay: 0.8s;
	-webkit-animation-delay: 0.8s;
}
@keyframes show-draw-hr{
    100% {
        /* width: 82%; */
        transform-origin: left top;
        width: 84%;
        }
    }
#labelhr {
  margin: 30px 0;
  float: right;
  width: 2%;
  border: solid 0.7px #c6c3c3;
  animation: show-draw-hr 0.9s ease-out forwards;
  -webkit-animation: show-draw-hr 0.9s ease-out forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
}

.content{
  display: inline-block;
  width:100%;
  height:auto;
  margin: 3% 0 -2% 0;
}

.description{
  width: 44%;
  float: left;
}

.description_hr{
  margin: 0 21px 0 1px;
  display: inline-block;
  width: 0px;
  height: 260px;
  border: solid 0.5px #bbb19d;
  object-fit: contain;
  opacity: 0;
}
.description_hr.activehr{
  animation: showhr 0.9s ease-in forwards;
  -webkit-animation: showhr 0.9s ease-in forwards;
  animation-delay: 2s;
	-webkit-animation-delay:  2s;
}
.description_hr.activehrlate{
  animation: showhr 0.9s ease-in forwards;
  -webkit-animation: showhr 0.9s ease-in forwards;
  /* animation-delay: 1.6s;
	-webkit-animation-delay:  1.6s; */
}
@keyframes showhr{
    0%{
        opacity: 0;
      /* transform: translateY(14px); */
    }
    100% {
        opacity: 1;
        }
    }

#description_text{
  margin-bottom: 10%;
  width: 90%;
  height: auto;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #7d7d7d;
  opacity: 0;
  animation: showtitle 0.9s ease-in forwards;
  -webkit-animation: showtitle 0.9s ease-in forwards;
  animation-delay: 2s;
	-webkit-animation-delay:  2s;
}
@keyframes showtitle{
    0%{
      transform: translateY(14px);
    }
    100% {
        opacity: 1;
        }
    }
.description_box{
  display: inline-block;
  width: 80%;
  margin: auto 3%;
  opacity: 0;
}
.description_box.activehr{
  animation: showtext 0.9s ease-in forwards;
  -webkit-animation: showtext 0.9s ease-in forwards;
  animation-delay: 2s;
	-webkit-animation-delay:  2s;
}
@keyframes showtext{
    100% {
      opacity: 1;
      transform: translateY(4px);
        }
    }
.descri_title {
  margin: auto 0;
  width: 100px;
  height: 48px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #a89a80;
}
.descri_content{
  margin: auto 0;
  width: 260px;
  height: 48px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #7d7d7d;
}
.figure{
  float: right;
  margin: -2% 0 0 1%;
  padding-bottom: 40px;
  padding-top: 10%;
  display: block;
  width:55%;
  /* width: 700px;
  height: 520px; */
  background-image: linear-gradient(320deg, #c4c3c283, #dadad9 3%, #ebebeb 18%, #feffffa2, #ffffff);
}
#goldenlv{
  width: 588px;
  height: auto;
  margin-left: 30px;
  margin-bottom: 40px;
  position: relative;
  opacity: 0;
  animation: showtitle 0.9s ease-in forwards;
  -webkit-animation: showtitle 0.9s ease-in forwards;
  animation-delay: 1.2s;
	-webkit-animation-delay:  1.2s;
}

.house, .shop{
  display: block;
  width: 100%;
  margin: 5% 0;
}
.house_box, .shop_box{
  display: inline-block;
  margin: auto auto;
  opacity: 0;
}
.house_box.activehrlate{
  animation: showtext 0.9s ease-in forwards;
  -webkit-animation: showtext 0.9s ease-in forwards;
  animation-delay: 0.5s;
  -webkit-animation-delay: 0.5s;
}
.shop_box.activehrlater{
  animation: showtext 0.9s ease-in forwards;
  -webkit-animation: showtext 0.9s ease-in forwards;
  animation-delay: 0.3s; 
  -webkit-animation-delay: 0.3s; 
}
.shop_hr{
  margin: 0 21px 0 0;
  display: inline-block;
  width: 0px;
  height: 55px;
  border: solid 0.7px #bbb19d;
  object-fit: contain;
  opacity: 0;
}
.shop_hr.activehrlater{
  animation: showtext 0.9s ease-in forwards;
  -webkit-animation: showtext 0.9s ease-in forwards;
  animation-delay: 0.3s; 
  -webkit-animation-delay: 0.3s; 
}
.shop_title {
  margin: auto 0;
  width: 10%;
  height: 48px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #a89a80;
}
.shop_content{
  margin: auto 0;
  width: 80%;
  height: 48px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #7d7d7d;
}

.photo_container{
  display: block;
  width: 100%;
  margin: 5% 0;
  padding: 0 10%;
}
.photo{
  width: 70%;
  height: auto;
  margin: 4% auto;
  opacity: 0;
}
#photoshow1,#photoshow2,#photoshow3,#photoshow4{   
  animation: showtext 0.9s ease-in forwards;
  -webkit-animation: showtext 0.9s ease-in forwards;
  animation-delay: 0.3s; 
  -webkit-animation-delay: 0.3s; 
  }

@media screen and (min-width:1600px) and (max-width:1800px){
.content{
  width: 110%;
  padding-right: 2.5%;
}
.figure{
  margin-top: -4%;
}
}
@media screen and (min-width:1801px){
.content{
  width: 110%;
  padding-right: 2.5%;
}
.figure{
  margin-top: -4.7%;
}
}
</style>